import { memo, FunctionComponent } from 'react';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)
import { Link } from 'react-router-dom';
import { Post } from '~components/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  getNews: Post;
  index: number;
}

export const News: FunctionComponent<Props> = memo(({ getNews, index }) => {
  const { t } = useTranslation();

  const tag = getNews.tags[0]?.name;

  return (
    <Link
      className={`news ${index === 0 && 'news-big'}`}
      to={`/blog/post/${getNews?.id}`}
    >
      {tag && <span className="news-badge">{t(`blog tag ${tag}`)}</span>}
      <img
        src={`https://keystone.trustunboxing.com${getNews?.background?.url}`}
        alt={getNews?.title}
      />
      <span className="news-content">
        <span className="news-name">{getNews?.title}</span>
        <span className="news-author">
          <img
            className="news-author-logo"
            src={`https://keystone.trustunboxing.com${getNews?.author?.avatar?.url}`}
            alt={getNews?.author?.name}
          />
          <span className="news-author-content">
            <span className="news-author-name">{getNews?.author?.name}</span>
            <span className="news-author-date">
              {dayjs(getNews?.publishDate).calendar()}
            </span>
          </span>
        </span>
      </span>
    </Link>
  );
});
